import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NotificationAlertComponent } from 'src/app/components/notification-alert/notification-alert.component';
import {
  AI_CREDITS_MIN_QUANTITY,
  AI_CREDITS_QUANTITY_STEP,
} from 'src/app/components/plans/plans.service';
import { QuantityComponent } from 'src/app/components/quantity/quantity.component';
import { RvSpinnerDirective } from 'src/app/components/loading/rv-spinner.directive';
import { PurchaseAiCreditsService } from '../../services/purchase-ai-credits.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { PaymentSchedulePickerComponent } from '../payment-schedule-picker/payment-schedule-picker.component';

@Component({
  selector: 'purchase-ai-credits',
  templateUrl: './purchase-ai-credits.component.html',
  styleUrls: ['./purchase-ai-credits.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationAlertComponent,
    PaymentSchedulePickerComponent,
    QuantityComponent,
    RvSpinnerDirective,
  ],
  standalone: true,
})
export class PurchaseAiCreditsComponent implements OnInit {
  readonly quantityStep = AI_CREDITS_QUANTITY_STEP;
  readonly quantityMin = AI_CREDITS_MIN_QUANTITY;

  addCoupon = false;
  couponCode = '';

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public purchaseAiCreditsService: PurchaseAiCreditsService,
    private purchaseStepsService: PurchaseStepsService,
  ) {}

  ngOnInit(): void {
    this.form.controls.quantity.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.onQuantityChange());
    this.form.controls.scheduleProductCode.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.onScheduleChange());
  }

  get form() {
    return this.purchaseAiCreditsService.form;
  }

  onQuantityChange(): void {
    this.purchaseAiCreditsService.onQuantityOrScheduleChanged();
  }

  onScheduleChange(): void {
    this.purchaseAiCreditsService.onQuantityOrScheduleChanged();
  }

  applyCouponCode(): void {
    this.purchaseAiCreditsService.couponCode = this.couponCode;
    this.purchaseAiCreditsService.applyCouponCode().then(() => {
      if (!this.purchaseAiCreditsService.estimate.estimateError) {
        this.addCoupon = false;
      }
    });
  }

  clearCouponCode(): void {
    this.couponCode = '';
    this.purchaseAiCreditsService.clearCouponCode();
    this.addCoupon = false;
  }

  cancel(): void {
    this.purchaseAiCreditsService.cancel();
  }

  continue(): void {
    this.purchaseAiCreditsService.continue().then((canProceed) => {
      if (canProceed) {
        this.purchaseStepsService.setNextStep();
      }
    });
  }
}
